const NotFound = () => {
  return <div>잘못된 경로입니다!</div>;
};

export default NotFound;
